import { StoreState } from '@/redux/types';
import { getDraft } from './getDraft';

export const getConfigurationIds = (state: StoreState) => getDraft(state).configurationIds;
